import Header from "../Components/header";
import Footer from "../Components/footer";
import ErrSection from "../Components/errsection";

function ErrorPage() {
    return(
    <>
    <Header/>
    <ErrSection/>
    <Footer/>
    </>
    );
}

export default ErrorPage